import RectangleButton from "@/components/molecules/rectangleButton";
import { clientFetch } from "@/sanity/lib/client";
import { getFileAsset } from "@sanity/asset-utils";

const ButtonGroup = ({ ctaButton }) => {
  const base =
    "relative w-full flex flex-wrap gap-[20px] md:gap-[34px] mt-smallDesktop lg:mt-[30px]";
  return (
    <div className={base}>
      <RectangleButton name="VIEW ALL FACILITIES" link="/facilities" />
      <RectangleButton
        name={ctaButton.name}
        link={
          ctaButton.option === "link"
            ? ctaButton.link
            : getFileAsset(ctaButton.pdf, clientFetch.config())
                .url
        }
        target="_blank"
      />
    </div>
  );
};

export default ButtonGroup;
